/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { instoreOfferOverlayClick } from 'core/modules/Instore/OffersSection/actions';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import MerchantInfo from '../MerchantInfo/MerchantInfo';
import OfferButtonAndCardInfo from '../OfferButtonAndCardInfo/OfferButtonAndCardInfo';
import RebateInfo from '../MerchantInfo/components/RebateInfo';

import './Offer.scss';

function Offer({ offer }) {
  const dispatch = useDispatch();
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const {
    rclonMerchantName, carteraMerchantName, displayRate, currency, linked, expiringSoon, offerId, showError,
    carteraMerchantId, carteraMerchantLogoUrls: { _88x31, _120x60 }, eligibleCards, linkedCards, redemptionEndDate,
    daysToExpire, imageUrl,
  } = offer;

  const clickHandler = (offer) => {
    const { offerId } = offer;
    dispatch(instoreOfferOverlayClick({
      offerId,
    }));
  };

  if (isMobileMQ) {
    return (
      <div
        className="mn_instoreOfferRow"
        data-test="instore-offer-rendered"
        data-offer-id={offerId}
        data-is-linked={!!linkedCards.length}
        data-gmid-and-merchant-name={`${carteraMerchantId}:${carteraMerchantName}`}
        onClick={() => clickHandler(offer)}
        role="listitem"
      >
        <MerchantInfo
          merchantName={rclonMerchantName}
          displayRate={displayRate}
          currency={currency}
          merchantImg={_88x31 || imageUrl || _120x60}
        />
        <OfferButtonAndCardInfo
          offerId={offerId}
          merchantName={rclonMerchantName}
          merchantNameAndGmid={`${carteraMerchantId}:${carteraMerchantName}`}
          isLinkedCards={linked}
          expiringSoon={expiringSoon}
          redemptionEndDate={redemptionEndDate}
          showError={showError}
          cardsAvailable={eligibleCards.length}
          daysToExpire={daysToExpire}
          totalCards={eligibleCards.length + linkedCards.length}
        />
      </div>
    );
  }

  return (
    <div
      className="mn_instoreOfferRow"
      data-test="instore-offer-rendered"
      data-offer-id={offerId}
      data-is-linked={!!linkedCards.length}
      data-gmid-and-merchant-name={`${carteraMerchantId}:${carteraMerchantName}`}
      role="listitem"
    >
      <div className="mn_instoreMerchantInfo" onClick={() => clickHandler(offer)}>
        <div className="mn_instoreOfferMoreInfoIconWrap">
          <button
            className="mn_instoreOfferMoreInfoIcon"
            aria-label="Opens a dialog with in-store offer details for Johnston and Murphy"
          />
        </div>
        <img src={_120x60 || imageUrl} alt={rclonMerchantName} />
      </div>
      <div className="mn_rebateWrap">
        <p className="mn_linkOfferText">Link offer and</p>
        <RebateInfo displayRate={displayRate} currency={currency} />
      </div>
      <OfferButtonAndCardInfo
        offerId={offerId}
        merchantName={rclonMerchantName}
        merchantNameAndGmid={`${carteraMerchantId}:${carteraMerchantName}`}
        isLinkedCards={linked}
        expiringSoon={expiringSoon}
        redemptionEndDate={redemptionEndDate}
        showError={showError}
        cardsAvailable={eligibleCards.length}
        daysToExpire={daysToExpire}
        totalCards={eligibleCards.length + linkedCards.length}
      />
    </div>
  );
}

export default Offer;
